import { motion } from "framer-motion";
import { useNavigate, useLocation } from "react-router-dom";

export const WA_NUMBER = "6589966507";
export const PHONE_DISPLAY = "+65 8996 6507";
export const EMAIL = "afztechsolutions@gmail.com";
export const ADDRESS = "52 Jalan Kembangan, Singapore 419118";
export const HOURS = "Mon – Sun · 12:00 PM – 8:00 PM";

export const waLink = (text) =>
  `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(text)}`;

// Google Maps — interactive embed + turn-by-turn directions from Kembangan MRT (EW6)
export const MAP_EMBED_URL =
  "https://maps.google.com/maps?q=52%20Jalan%20Kembangan%2C%20Singapore%20419118&z=17&output=embed";
export const DIRECTIONS_FROM_MRT_URL =
  "https://www.google.com/maps/dir/Kembangan+MRT+Station,+Singapore/52+Jalan+Kembangan,+Singapore+419118";
export const MAP_LOCATION_URL =
  "https://www.google.com/maps/search/?api=1&query=52+Jalan+Kembangan+Singapore+419118";

export const WA_DEFAULT = waLink(
  "Hello AFZ Tech Solution, I need help with a device repair."
);

export const scrollToId = (id) => {
  const el = document.querySelector(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

// Router-aware navigation to a home-page section. Works from any route.
export const useSectionNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  return (href) => {
    if (location.pathname === "/") {
      scrollToId(href);
    } else {
      navigate("/", { state: { scrollTo: href } });
    }
  };
};

export const Reveal = ({ children, delay = 0, y = 40, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ eyebrow, title, accent, sub, align = "left" }) => (
  <div className={align === "center" ? "text-center" : "text-left"}>
    <Reveal>
      <p className="font-mono text-xs uppercase tracking-[0.3em] text-brand-lime mb-4">
        {eyebrow}
      </p>
    </Reveal>
    <Reveal delay={0.08}>
      <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold uppercase tracking-tight leading-[0.95] text-white">
        {title} {accent && <span className="text-brand-lime text-glow-lime">{accent}</span>}
      </h2>
    </Reveal>
    {sub && (
      <Reveal delay={0.16}>
        <p className={`mt-5 text-base text-slate-400 max-w-2xl leading-relaxed ${align === "center" ? "mx-auto" : ""}`}>
          {sub}
        </p>
      </Reveal>
    )}
  </div>
);
